import { render, staticRenderFns } from "./WorkShift.vue?vue&type=template&id=2e3e6116&scoped=true"
import script from "./WorkShift.vue?vue&type=script&lang=js"
export * from "./WorkShift.vue?vue&type=script&lang=js"
import style0 from "./WorkShift.vue?vue&type=style&index=0&id=2e3e6116&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3e6116",
  null
  
)

export default component.exports